module.exports = __webpack_public_path__ + "img/226.fd8a94ad.jpg";